import { render, staticRenderFns } from "./ConsignmentStockQuery.vue?vue&type=template&id=0cdb4db5&scoped=true"
import script from "./ConsignmentStockQuery.vue?vue&type=script&lang=js"
export * from "./ConsignmentStockQuery.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentStockQuery.vue?vue&type=style&index=0&id=0cdb4db5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdb4db5",
  null
  
)

export default component.exports